import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useScrollToTop } from "./components/main/useScrolltoTop";
import { Toaster } from "react-hot-toast";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Chatbot from "./components/chatBot";
import AIEvent from "./components/main/ai-event";
import PhotoGallery from "./components/main/ai-event/photoGallery";
import NewHomePage from "./components/NewHomePage";
import DataAssistantPage from "./components/main/DataAssistantNew";
import { NewHeader } from "./components/NewHomePage/newHeader";
import { NewFooter } from "./components/NewHomePage/newFooter";
import AiPlatformNew from "./components/main/AiPlatformNew";
import Core from "./components/main/Core";
import TechnologyPage from "./components/main/Technology";
import BlogsNewPage from "./components/main/blog-new/BlogsNew";
import AboutUS from "./components/main/company/AboutUs";
import CareersPage from "./components/main/careers-new/CareersPage";
import InfoSecurityPage from "./components/main/info/InformationSecuirty";
import LegalInfo from "./components/main/info/LegalInfo";
import Faqs from "./components/main/faqs/Faqs";
import ContactsPage from "./components/main/contact/ContactsPage";
import SingleBlogNew from "./components/main/blog-new/SingleBlogNew";
import DemoModal from "./components/demoModal";
import CapitalMarketsPage from "./components/main/solutions/CapitalMarkets";
import FinancialMarketsPage from "./components/main/solutions/FinancialMarkets";
import EnterpriseMarketsPage from "./components/main/solutions/EnterpriseMarkets";
import Pulse from "./components/main/Pulse";
import TradeAssistantPage from "./components/main/TradeAssistant";
import OurPartnersPage from "./components/main/company/OurPartners";
import SpeedataPage from "./components/main/Speedata";

function App() {
  useScrollToTop();
  const location = useLocation(); // Get the current path

  return (
    <main className="App relative">
      {!location.pathname.includes(
        "/event/ai-data-stack-connect-2025/gallery",
      ) && <NewHeader />}

      <Routes>
        <Route exact path="/" element={<NewHomePage />} />
        <Route exact path="/ai-platform" element={<AiPlatformNew />} />
        <Route exact path="/data-assistant" element={<DataAssistantPage />} />
        <Route exact path="/tradetutor" element={<TradeAssistantPage />} />
        <Route exact path="/partners" element={<OurPartnersPage />} />
        <Route
          exact
          path="/event/ai-data-stack-connect-2025"
          element={<AIEvent />}
        />
        <Route
          exact
          path="/event/ai-data-stack-connect-2025/gallery"
          element={<PhotoGallery />}
        />
        <Route exact path="/blog" element={<BlogsNewPage />} />
        <Route exact path="/blog/:id" element={<SingleBlogNew />} />
        <Route exact path="/core" element={<Core />} />
        <Route exact path="/pulse" element={<Pulse />} />
        <Route exact path="/about-us" element={<AboutUS />} />
        <Route exact path="/careers" element={<CareersPage />} />
        <Route exact path="/isms-bcms" element={<InfoSecurityPage />} />
        <Route exact path="/legal-info" element={<LegalInfo />} />
        <Route exact path="/faqs" element={<Faqs />} />
        <Route exact path="/contact" element={<ContactsPage />} />
        <Route
          exact
          path="solutions/capital-markets"
          element={<CapitalMarketsPage />}
        />
        <Route
          exact
          path="solutions/financial-markets"
          element={<FinancialMarketsPage />}
        />
        <Route
          exact
          path="solutions/enterprises"
          element={<EnterpriseMarketsPage />}
        />
        <Route exact path="technology" element={<TechnologyPage />} />
        <Route exact path="/speedata" element={<SpeedataPage />} />
        <Route path="*" element={<Navigate reloadDocument to="/" replace />} />
      </Routes>

      <DemoModal />
      <NewFooter />

      {!location.pathname.includes("/event/ai-data-stack-connect-2025") && (
        <Chatbot />
      )}

      <Toaster
        toastOptions={{
          style: {
            maxWidth: "700px",
            padding: "12px 16px",
            fontSize: "17px",
            fontWeight: "400",
          },
          error: {
            style: {
              color: "red",
            },
          },
          success: {
            style: {
              color: "green",
            },
          },
        }}
        position="top-center"
        reverseOrder={false}
      />

      <style jsx="true">
        {`
          .Toastify__toast-container {
            z-index: 9999999;
          }
        `}
      </style>
    </main>
  );
}

export default App;
